module.exports = __webpack_public_path__ + "img/bg.17c6fbff.jpg";